import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useProps, useStore } from '../../utils/mobx.utils';
import './UsernameRenderer.scss';
var UsernameRenderer = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get color() {
            var _a, _b;
            return (_a = p.user.color) !== null && _a !== void 0 ? _a : (_b = p.user.preferences) === null || _b === void 0 ? void 0 : _b.color;
        },
    }); });
    return React.createElement(Observer, { children: function () {
            var _a;
            return (React.createElement("span", { className: "UsernameRenderer", "data-user-id": p.user.id },
                (p.showColorLabel === undefined || !!p.showColorLabel) && React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "UsernameRendererColorDot", style: { backgroundColor: (_a = s.color) !== null && _a !== void 0 ? _a : undefined } }),
                    "\u00A0"),
                React.createElement("span", { className: "UsernameRendererLabel" }, p.user.username)));
        } });
};
export default UsernameRenderer;
